import { render, staticRenderFns } from "./StElem.vue?vue&type=template&id=36afd166&"
import script from "./StElem.vue?vue&type=script&lang=js&"
export * from "./StElem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports